<ion-icon [src]="icon" [style.color]="'var(--ion-color-step-950)'"> </ion-icon>
<h1>
  {{ title }}
</h1>
